import config from "../_config";


function getImageURL(image) {
    return image ? image.includes("http") || image.includes("base64") ? image
        : config.baseUrl + encodeURI(image) : "/assets/images/default.jpg";
}
export default getImageURL;